import React from 'react';

interface IPainClockProps {
  width?: number;
  height?: number;
}

export const PainClock: React.FC<IPainClockProps> = ({
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="20" fill="#F1FCEF" />
      <circle cx="24" cy="24" r="20" stroke="#4CAF50" strokeWidth="2" />
      <path
        d="M24 14V24L30 28"
        stroke="#4CAF50"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
